import { API } from "./adventureApi";

const TOKEN_KEY = "wf_token";
const USER_KEY = "wf_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
};
const storeUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u || {}));

export const getRole = () => getUser()?.role || null;
export const isAuthed = () => !!getToken();
export const isAdmin = () => getRole() === "admin";
export const isAgency = () => getRole() === "agency";
export const isTradeUser = () => ["trade", "agency", "admin"].includes(getRole());
export const isMpn = () => getRole() === "mpn";

export const setUser = (u) => storeUser(u);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function login(email, password) {
  const res = await fetch(`${API}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(typeof err.detail === "string" ? err.detail : "Login failed");
  }
  const data = await res.json();
  setToken(data.token);
  storeUser(data.user);
  return data.user;
}

export async function register(payload) {
  const res = await fetch(`${API}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(typeof err.detail === "string" ? err.detail : "Registration failed");
  }
  const data = await res.json();
  setToken(data.token);
  storeUser(data.user);
  return data.user;
}

export async function applyMpn(payload) {
  const res = await fetch(`${API}/mpn/apply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(typeof err.detail === "string" ? err.detail : "Application failed");
  }
  const data = await res.json();
  setToken(data.token);
  storeUser(data.user);
  return data.user;
}

export async function fetchMpnMe() {
  const res = await fetch(`${API}/mpn/me`, { headers: authHeader() });
  if (!res.ok) throw new Error("unauthorized");
  const u = await res.json();
  storeUser(u);
  return u;
}

export async function updateAgency(payload) {
  const res = await fetch(`${API}/agency/me`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Could not save profile");
  const u = await res.json();
  storeUser(u);
  return u;
}

// admin-only endpoint (owner console)
export async function fetchMe() {
  const res = await fetch(`${API}/auth/me`, { headers: authHeader() });
  if (!res.ok) throw new Error("unauthorized");
  return res.json();
}

// trade OR admin — validates the shared portal session
export async function verifySession() {
  const res = await fetch(`${API}/auth/session`, { headers: authHeader() });
  if (!res.ok) throw new Error("unauthorized");
  return res.json();
}
